<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-26 15:30:20
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-11-02 16:22:58
 * @FilePath: \合联\oms\src\view\storage\addHistory\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-26 15:30:20
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-26 15:30:48
 * @FilePath: \合联\oms\src\view\storage\addHistory\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/storage/addHistory.js'
export default {
  name: "",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: 'client_id',
            placeholder() {
              return this.$tz('客户名称')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getAllClient',
            optionsKey: '',
          },
          {
            key: 'warehouse_id',
            placeholder() {
              return this.$tz('仓库名称')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getWarehouse',
            optionsKey: '',
          },
          {
            key: 'direction',
            placeholder() {
              return this.$tz('操作,类型')
            },
            component: 'Select',
            options: [],
            optionsFn: 'DownUp',
            optionsKey: '',
          },
          {
            key: 'keywords',
            placeholder() {
              return this.$t('keyword');
            },
            component: 'Input',
            bind: {
              type: 'textarea',
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
              disabled() { return !this.selectAll.length }
            },
          ],
          methods: {
            export() {
              this.exportExc()
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          width: 50,
        },
        {
          name: () => this.$t("clientName"),
          key: "customer",
          minWidth: 130,
        },
        {
          name: () => this.$t("warehouseName2"),
          key: "warehouse_name",
          minWidth: 130,
        },
        {
          name: () => this.$tz("库位,名称"),
          key: "location_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("skuName1"),
          key: "goods_name",
          minWidth: 130,
        },
        {
          name: () => this.$tz("商品,SKU"),
          key: "sku",
          minWidth: 130,
        },
        {
          name: () => this.$tz("操作,类型"),
          key: "type",
          minWidth: 130,
        },
        {
          name: () => this.$tz('操作,方式'),
          key: 'operate_type',
          minWidth: 110,
        },
        {
          name: () => this.$tz("操作,数量"),
          key: "number",
          minWidth: 130,
        },
        {
          name: () => this.$tz("操作,日期"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz('操作,账号'),
          key: 'operate_name',
          minWidth: 110,
        },
      ]
    }
  }
}
</script>

<style scoped></style>
